import { render, staticRenderFns } from "./Puntos_salida.vue?vue&type=template&id=542e3431"
import script from "./Puntos_salida.vue?vue&type=script&lang=js"
export * from "./Puntos_salida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports